module.exports = __webpack_public_path__ + "media/images/spree/frontend/credit_cards/icons/switch-00a1862a7f7a7d60d26b30bf6793d6a0.png";